// src/api/authApi.js
import axios from 'axios';
const API = process.env.REACT_APP_API_BASE || 'http://localhost:4000/api';

export const loginApi = async (email, password) => {
  const resp = await axios.post(`${API}/login`, { email, password });
  return resp.data;
};

export const registerApi = async (userData) => {
  const resp = await axios.post(`${API}/register`, userData);
  return resp.data;
};

export const verifyTokenApi = async (token) => {
  const resp = await axios.get(`${API}/verify`, { 
    headers: { Authorization: `Bearer ${token}` } 
  });
  return resp.data;
};

export const getProfileApi = async (token) => {
  const resp = await axios.get(`${API}/profile`, { 
    headers: { Authorization: `Bearer ${token}` } 
  });
  return resp.data;
};

export default {
  loginApi,
  registerApi,
  verifyTokenApi,
  getProfileApi,
};
